module.exports = __webpack_public_path__ + "img/levelup_icon_expense.13e6a4cb.svg";